import { render, staticRenderFns } from "./Sm700Black.vue?vue&type=template&id=96c91d72&scoped=true&"
var script = {}
import style0 from "./Sm700Black.vue?vue&type=style&index=0&id=96c91d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c91d72",
  null
  
)

export default component.exports